var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTaskComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.625 52.6612L37.6069 47.6431L34.875 50.3749L42.625 58.1249L58.125 42.6249L55.3931 39.8931L42.625 52.6612Z",
    fill: "#873CAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4375 9.6875H42.625V7.75C42.6219 6.72323 42.2127 5.73939 41.4867 5.01335C40.7606 4.28731 39.7768 3.87807 38.75 3.875H23.25C22.2232 3.87807 21.2394 4.28731 20.5133 5.01335C19.7873 5.73939 19.3781 6.72323 19.375 7.75V9.6875H13.5625C12.5357 9.69057 11.5519 10.0998 10.8258 10.8258C10.0998 11.5519 9.69057 12.5357 9.6875 13.5625V54.25C9.69057 55.2768 10.0998 56.2606 10.8258 56.9867C11.5519 57.7127 12.5357 58.1219 13.5625 58.125H31V54.25H13.5625V13.5625H19.375V19.375H42.625V13.5625H48.4375V34.875H52.3125V13.5625C52.3094 12.5357 51.9002 11.5519 51.1742 10.8258C50.4481 10.0998 49.4643 9.69057 48.4375 9.6875ZM38.75 15.5H23.25V7.75H38.75V15.5Z",
    fill: "#873CAA",
    fillOpacity: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskComplete);
export default __webpack_public_path__ + "static/media/task_complete.7d1cfec16271c77e4d7e1412e9fa24f7.svg";
export { ForwardRef as ReactComponent };